import Datagrid from 'src/components/Datagrid/Datagrid';
import {
  ENTITIES,
  QuerbuilderPayloadColumns,
  QuerbuilderPayloadOrder,
} from 'src/models/QuerybuilderModel';
import DatagridSearch from 'src/components/DatagridSearch/DatagridSearch';
import DatagridToolbar from 'src/components/DatagridToolbar/DatagridToolbar';
import { useEffect } from 'react';
import { setColumns, setOrders } from 'src/redux/actions/querybuilderActions';
import DEFAULT_COLUMNS from 'src/constants/columns';
import { Store, useAppDispatch } from 'src/redux/Store';
import { useSelector } from 'react-redux';
import { Preset, PRESET_TYPES } from 'src/models/PresetModel';
import { setSelectedPresets } from 'src/redux/actions/selectedPresetActions';

interface DefaultPreset {
  defaultLayout: Nullable<Preset>,
  defaultLayoutId: number,
}

const entity = ENTITIES.recurrings;

const SubscriptionsPage = () => {
  const dispatch = useAppDispatch();

  const { defaultLayout, defaultLayoutId } = useSelector(
    (state: Store): DefaultPreset => {
      const empty = {
        defaultLayout: null,
        defaultLayoutId: 0,
      } as DefaultPreset;
      const type = PRESET_TYPES.layout;
      if (!state.presets[entity]) return empty;
      if (!state.presets[entity][type]) return empty;
      const storedPreset = state.presets[entity][type].find((preset) => preset.is_default);
      if (storedPreset) {
        return {
          defaultLayout: storedPreset,
          defaultLayoutId: storedPreset.id,
        } as DefaultPreset;
      }
      return empty;
    },
  );

  useEffect(() => {
    dispatch(setSelectedPresets({
      entity,
      type: PRESET_TYPES.layout,
      id: defaultLayoutId,
    }));
    dispatch(setColumns({
      entity,
      columns: defaultLayout?.filter || DEFAULT_COLUMNS[entity],
    } as QuerbuilderPayloadColumns));
    dispatch(setOrders({
      entity,
      order: defaultLayout?.order,
    } as QuerbuilderPayloadOrder));
  }, []);

  return (
    <>
      <DatagridSearch entity={entity} />
      <DatagridToolbar entity={entity} />
      <Datagrid entity={entity} />
    </>
  );
};

export default SubscriptionsPage;
